import React, {Component} from 'react';
import {connect} from 'react-redux';
import SweetAlert from 'sweetalert-react';
import {calculateAge} from '../../../utils/utils';
import * as UserActions from '../../../actions/userActions';
import Loader from '../../../components/commons/loader/loader';
import Moment from 'moment';
class BirthdayWall extends Component {

  constructor(props){
    super(props);
    this.state = {
      dob:'',
      showAlert: false,
      swalParams: {
        title: ""
      }
    }
    this.onSubmit = this.onSubmit.bind(this);
  }

  componentDidMount() {

    window.onkeydown = null;
  }

  render() {

    const {dob, showAlert, swalParams} = this.state;
    const {loading} = this.props;
    return (
      <div className="page forgot-password-page">
        <div className="container">
          <h1 className="page-title">Enter Birthday</h1>
          <div className="row">
            <div className="col-md-6">
              <form onSubmit={this.onSubmit}>
                <input required type="date" aria-label="Enter date" className="email-input" onChange={(e)=>this.setState({dob:e.target.value})} value={dob} placeholder="Enter date"/>
                <button type="submit" className="reset-password-button" >Submit</button>
              </form>
            </div>
          </div>
        </div>
        <Loader visibility={loading} />
        <SweetAlert customClass={"with-close"} showCancelButton cancelButtonText={"x"} onCancel={()=> this.setState({showAlert:false})} show={showAlert} {...swalParams} onConfirm={() => this.setState({showAlert: false})}/>
      </div>
    )
  }
  
  onSubmit(e) {
    e.preventDefault();

    const {dob} = this.state;
    let formattedDob = Moment(dob).format("MM/DD/YYYY");
    let ageData = calculateAge(formattedDob);
    
    if (ageData.status == 0) {
      if (ageData.age < 21) {
        this.setState({
          showAlert: true,customClass:"with-close",
          swalParams: {
            title: 'Sorry! you are too young!',
            type: "error",
            showConfirmButton: false
          }
        });
        return;
      }}
    let tempUser = {
     
      dob: dob,
    }
    this.props.dispatch(UserActions.saveProfileDetails(tempUser, response => {
      if (response.status) {
        let user = response.data;
        this.setState({
            dob: user && user.dob
            ? user.dob
            : '',
        }, () => {
          this.setState({
            showAlert: true,customClass:"with-close",
            swalParams: {
              title: 'Profile saved successfully!',
              type: "success",
              showConfirmButton: false
            }
          })
          this.props.history.push('/');
          // setTimeout(() => this.setState({showAlert: false}), 2000);
        })
      } else {
        this.setState({
          showAlert: true,customClass:"with-close",
          swalParams: {
            title: 'Failed to save profile, please try again later!',
            type: "error",
            showConfirmButton: false
          }
        })
        // setTimeout(() => this.setState({showAlert: false}), 2000);
      }
    }))
  }
}


export default connect((state) => {
  return {
    error: state.getIn(['users', 'error']),
    loading: state.getIn(['users', 'loading'])
  };
})(BirthdayWall);



// WEBPACK FOOTER //
// ./src/containers/begin/birthday-wall/BirthdayWall.js